import type { SVGProps } from "react";
import * as React from "react";

const SvgAnchor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 13a1 1 0 1 0 0-2zm-3-1v-1a1 1 0 0 0-1 1zm20 0h1a1 1 0 0 0-1-1zm-3-1a1 1 0 1 0 0 2zm-5-6a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2H8a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2V1a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zm1 19V8h-2v14zM5 11H2v2h3zm-4 1a11 11 0 0 0 3.222 7.778l1.414-1.414A9 9 0 0 1 3 12zm3.222 7.778A11 11 0 0 0 12 23v-2a9 9 0 0 1-6.364-2.636zM12 23a11 11 0 0 0 7.778-3.222l-1.414-1.414A9 9 0 0 1 12 21zm7.778-3.222A11 11 0 0 0 23 12h-2a9 9 0 0 1-2.636 6.364zM22 11h-3v2h3z"
    />
  </svg>
);
export default SvgAnchor;
